import { AnalyticsListener } from '@atlaskit/analytics-next';
import { getSentryClient } from '@atlassian/mpac-utils';
import React, { useEffect, useRef } from 'react';
import { useLocation } from '../Router/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const isKnownGASv3UIEvent = event => event.payload.eventType && event.payload.eventType.type === 'ui' && event.payload.eventType.action && event.payload.actionSubjectId;

/**
 * See https://develop.sentry.dev/sdk/event-payloads/breadcrumbs/#breadcrumb-types
 */

const addBreadcrumb = (action, actionSubjectId, description) => {
  var _getSentryClient;
  (_getSentryClient = getSentryClient()) === null || _getSentryClient === void 0 ? void 0 : _getSentryClient.addBreadcrumb({
    category: "ui.".concat(action),
    message: "".concat(description, " ").concat(actionSubjectId) || "User performed ".concat(action, " on ").concat(actionSubjectId),
    level: 'info'
  });
};
const useSentryPageParamTag = (getRouteName, getRouteParams) => {
  const {
    pathname
  } = useLocation();
  const currentPageParams = useRef(getRouteParams(pathname) || {});
  useEffect(() => {
    var _getSentryClient3;
    // Tags once set, live for the lifecycle of the application. We need to unset
    // them between SPA transitions. See https://github.com/getsentry/sentry-javascript/issues/2218
    Object.keys(currentPageParams.current).forEach(key => {
      var _getSentryClient2;
      (_getSentryClient2 = getSentryClient()) === null || _getSentryClient2 === void 0 ? void 0 : _getSentryClient2.setTag(key, undefined);
    });

    // And new params are set
    currentPageParams.current = getRouteParams(pathname) || {};
    (_getSentryClient3 = getSentryClient()) === null || _getSentryClient3 === void 0 ? void 0 : _getSentryClient3.setTag('pageName', getRouteName(pathname));
    Object.entries(currentPageParams.current).forEach(_ref => {
      var _getSentryClient4;
      let [key, value] = _ref;
      (_getSentryClient4 = getSentryClient()) === null || _getSentryClient4 === void 0 ? void 0 : _getSentryClient4.setTag(key, value);
    });
  }, [pathname]);
};
const SentryGASv3Listener = _ref2 => {
  let {
    children,
    getRouteName,
    getRouteParams
  } = _ref2;
  // Our top level analytics listener can catch a heterogeneous mix
  // of events, not all of which we might be interested in
  const handleAnalyticsEvent = e => {
    if (isKnownGASv3UIEvent(e)) {
      addBreadcrumb(e.payload.eventType.action, e.payload.actionSubjectId, e.payload.eventType.details);
    }
  };
  useSentryPageParamTag(getRouteName, getRouteParams);
  return /*#__PURE__*/_jsx(AnalyticsListener, {
    channel: "*",
    onEvent: handleAnalyticsEvent,
    children: children
  });
};
export default SentryGASv3Listener;